<template>
    <div class="form-group" :inputclass="inputclass">
        <label v-if="label != ''">{{label}}</label>
        <select2  v-model="data" :options="options" :defaultText="placeholder" :hideSearchBox="hideSearchBox" :allowClear="allowClear"></select2>
    </div>
</template>

<script>

import select2 from "./helpers/select2.vue";

export default {
    components: {
        select2
    },
    props: {
        value: {
            default: ""
        },
        options: {
            type: Array,
            default: []
        },
        inputclass :{
            type: String,
            default: ""
        },
        label :{
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        isLoading : {
            type: Boolean,
            default: false
        },
        hideSearchBox: {
            type: Boolean,
            default: false
        },
        allowClear : {
            type: Boolean,
            default: true
        }
    },
    watch: {
        isLoading (value, old) {

        },
        value (value, old) {

        },
    },
    mounted () {
        this.initialize();
    },
    computed: {
        data: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        }
    },
    methods : {
        initialize(){
        },
    }
};
</script>